import styled from "styled-components"

export const StyledSwitch = styled.div`
  display: flex;
`

export const FlexInner = styled.div`
  display: flex;
  flex-grow: 0;
  background: var(--white-white-5, rgba(255, 255, 255, 0.049));
  backdrop-filter: blur(60px);
  border-radius: 100px;
  position: relative;
`

export const SwitchOption = styled.div<{
  $isActive: boolean
  $width?: number
  $disabled: boolean
}>`
  display: flex;
  align-items: center;
  height: 32px;
  font-size: 12px;
  font-weight: 700;
  line-height: 12px; /* 100% */
  letter-spacing: 0.12px;
  z-index: 1;
  padding: 0 16px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  color: #fff;
`

export const ActiveMask = styled.div<{
  $activeIndex: number
  $width?: number
  $hasTransition: boolean
}>`
  background-color: rgb(70, 89, 103);
  backdrop-filter: blur(60px);
  border-radius: 100px;
  height: 100%;
  top: 0px;
  position: absolute;
  width: ${({ $width }) => $width}px;
  left: ${({ $activeIndex, $width }) =>
    $activeIndex === 0 ? "0px" : `calc(100% - ${$width}px)`};
  z-index: 0;
  border: 0.75px solid var(--Schemes-Outline, rgba(0, 38, 58, 0.14));

  transition: ${({ $hasTransition }) => ($hasTransition ? "all 0.2s" : "none")};
`
